export const GENE = "gene";
export const VARIANT = "variant";
export const REGION = "region";
export const LOOKUP = "lookup";
export const IDS = "ids";

export const ENTITIES = {
  [GENE]: "gene",
  [VARIANT]: "variant",
  [REGION]: "region",
  [LOOKUP]: "lookup",
  [IDS]: "ids",
};
